import { makeAutoObservable } from 'mobx';

export default class SocialResumeCreateRefStore {
  constructor() {
    makeAutoObservable(this);
  }

  resumeBaseInfoRef;

  descriptionRef;

  resumeEduExpListRef;

  resumeWorkExpListRef;

  resumeProjectExpListRef;

  resumeHonorListRef;

  resumeLanguageListRef;

  resumeCertificateListRef;

  resumePatentListRef;

  resumeExamListRef;

  resumeSocialAccountListRef;

  currentScrollRef;

  resumeBaseInfoTitleRef;

  // 校验
  validate = () => {
    const resumeBaseInfoRefs = this.resumeBaseInfoRef.validateFields();

    const resumeEduExpListRefs = this.resumeEduExpListRef.map((ref) => ref?.validateFields());
    const resumeWorkExpListRefs = this.resumeWorkExpListRef.map((ref) => ref?.validateFields());
    const resumeProjectExpListRefs = this.resumeProjectExpListRef.map((ref) => ref?.validateFields());
    const resumeHonorListRefs = this.resumeHonorListRef.map((ref) => ref?.validateFields());
    const resumeLanguageListRefs = this.resumeLanguageListRef.map((ref) => ref?.validateFields());
    const resumeCertificateListRefs = this.resumeCertificateListRef.map((ref) => ref?.validateFields());
    const resumePatentListRefs = this.resumePatentListRef.map((ref) => ref?.validateFields());
    const resumeExamListRefs = this.resumeExamListRef.map((ref) => ref?.validateFields());
    const resumeSocialAccountListRefs = this.resumeSocialAccountListRef.map((ref) => ref?.validateFields());

    const res = Promise.allSettled([
      resumeBaseInfoRefs,
      ...resumeEduExpListRefs,
      ...resumeWorkExpListRefs,
      ...resumeProjectExpListRefs,
      ...resumeHonorListRefs,
      ...resumeLanguageListRefs,
      ...resumeCertificateListRefs,
      ...resumePatentListRefs,
      ...resumeExamListRefs,
      ...resumeSocialAccountListRefs,
    ]).then((values) => {
      return values;
    });
    return res;
  };

  // 修改refs
  changeRef(key: string, value: any) {
    this[key] = value;
  }

  setCurrentScrollRef = (value: any) => {
    this.currentScrollRef = value;
  };
}
